import { PackagingOptions } from 'types/inventory';

export enum CountingValidationNameIds {
  RECEIVE_OFF_BY_NEGATIVE = 'receiveOffByNegative',
  RECEIVE_OFF_BY_POSITIVE = 'receiveOffByPositive',
  PASSIVE_HANDLING_OFF_BY_5_PLUS = 'passiveHandlingOffBy5Plus',
  PASSIVE_HANDLING_OFF_BY_LESS_THAN_5 = 'passiveHandlingOffByLessThan5',
  NON_PASSIVE_HANDLING_ANY_DISCREPANCY = 'nonPassiveHandlingAnyDiscrepancy',
  NULL_TAPE_SIZE = 'nullTapeSize',
}

export enum CountingValidationType {
  ERROR = 'error',
  WARNING = 'warning',
}

export type CountingValidation = {
  type: CountingValidationType;
  name: string;
  description: string;
  secondConfirmationDescription?: string;
  requiresDoubleConfirmation?: boolean;
  id: CountingValidationNameIds;
};

export type ValidationWithStatus = CountingValidation & {
  isResolved: boolean;
  resolutionLevel: number;
  stockLotId: string;
};

export interface ValidationParams {
  countedQuant: number | undefined;
  expectedQuant: number;
  isPassive?: boolean;
  isFromReceive?: boolean;
  stockLotId: string;
  isFromHandlingRequest?: boolean;
  handlingRequestType?: string;
  package: PackagingOptions;
  tapeSize: number | null;
}
